<template>
  <div class="mv2" :class="{ 'mv2--live': modoDiario }">

    <!-- ════════════════════ TOPBAR ════════════════════ -->
    <header class="mv2-bar">
      <div class="mv2-bar__brand">
        <span class="mv2-kicker">
          <span class="mv2-kicker__dot"></span>
          Harber · Sales atlas
          <span v-if="modoDiario" class="mv2-kicker__live">LIVE</span>
        </span>
        <h1 class="mv2-bar__title">Reporte <em>de ventas</em></h1>
      </div>

      <nav class="mv2-bar__nav">
        <a href="#mv2-mapa">Mapa</a>
        <a href="#mv2-paises">Países</a>
        <a href="#mv2-ciudades">Ciudades</a>
        <a href="#mv2-anual">Anual</a>
      </nav>

      <div class="mv2-bar__tools">
        <button class="mv2-date" @click="modalVisible = true" title="Filtrar por fecha">
          <i class="fa-solid fa-calendar-days"></i>
          <span v-if="modoDiario">Hoy · en directo</span>
          <span v-else>{{ fmt(dateRange.startDate) }} <em>→</em> {{ fmt(dateRange.endDate) }}</span>
          <b-spinner v-if="cargando" small type="grow" class="mv2-date__spin"></b-spinner>
        </button>

        <div class="mv2-seg" role="group" aria-label="Modo de cálculo">
          <button
            type="button"
            :class="{ 'is-on': tipoDatosCalcular === 'Libras' }"
            @click="tipoDatosCalcular = 'Libras'"
          ><i class="fa-solid fa-sterling-sign"></i> Libras</button>
          <button
            type="button"
            :class="{ 'is-on': tipoDatosCalcular === 'Ventas' }"
            @click="tipoDatosCalcular = 'Ventas'"
          ><i class="fa-solid fa-box"></i> Cantidad</button>
        </div>
      </div>
    </header>

    <!-- ════════════════════ HERO · MAPA ════════════════════ -->
    <section id="mv2-mapa" class="mv2-hero">
      <div class="mv2-hero__filters">
        <label class="mv2-field mv2-field--search">
          <i class="fa-solid fa-magnifying-glass"></i>
          <b-form-input
            v-model="searchQuery"
            placeholder="Pedido, SKU, producto…"
            debounce="300"
          />
        </label>
        <div class="mv2-field mv2-field--select">
          <v-select
            v-model="selectedCategory"
            :options="['Todas las categorías', ...categories]"
            :clearable="false"
            placeholder="Categoría"
          />
        </div>
        <button class="mv2-ghost" @click="resetMap" title="Centrar mapa">
          <i class="fa-solid fa-arrows-to-dot"></i>
        </button>
      </div>

      <div ref="mapContainer" class="mv2-hero__canvas"></div>

      <div v-if="cargando" class="mv2-hero__loading">
        <b-spinner type="grow" small></b-spinner>
        <span>Cargando pedidos…</span>
      </div>

      <aside class="mv2-hero__stats">
        <div class="mv2-stat">
          <span class="mv2-stat__n">{{ orders.length }}</span>
          <span class="mv2-stat__l">pedidos</span>
        </div>
        <div class="mv2-stat">
          <span class="mv2-stat__n">{{ visibleMarkers }}</span>
          <span class="mv2-stat__l">marcadores</span>
        </div>
        <div class="mv2-stat">
          <span class="mv2-stat__n">{{ categories.length }}</span>
          <span class="mv2-stat__l">categorías</span>
        </div>
      </aside>
    </section>

    <!-- ════════════════════ 01 · PAÍSES ════════════════════ -->
    <section id="mv2-paises" class="mv2-section" style="--i: 0">
      <header class="mv2-section__head">
        <span class="mv2-section__num">01</span>
        <h2 class="mv2-section__title">Países <em>y categorías</em></h2>
        <span class="mv2-section__meta">por {{ tipoDatosCalcular === 'Libras' ? 'libras' : 'cantidad' }}</span>
      </header>
      <div class="mv2-section__body">
        <GraficaPaises :items="orders" :tipoDatosCalcular="tipoDatosCalcular"></GraficaPaises>
      </div>
    </section>

    <!-- ════════════════════ 02 · CIUDADES ════════════════════ -->
    <section id="mv2-ciudades" class="mv2-section" style="--i: 1">
      <header class="mv2-section__head">
        <span class="mv2-section__num">02</span>
        <h2 class="mv2-section__title">Ciudades <em>y productos</em></h2>
        <span class="mv2-section__meta">por {{ tipoDatosCalcular === 'Libras' ? 'libras' : 'cantidad' }}</span>
      </header>
      <div class="mv2-section__body">
        <GraficaCiudades :items="orders" :tipoDatosCalcular="tipoDatosCalcular"></GraficaCiudades>
      </div>
    </section>

    <!-- ════════════════════ 03 · COMPARACIÓN ANUAL ════════════════════ -->
    <section id="mv2-anual" class="mv2-section" style="--i: 2">
      <header class="mv2-section__head">
        <span class="mv2-section__num">03</span>
        <h2 class="mv2-section__title">Comparación <em>anual</em></h2>
        <span class="mv2-section__meta">
          <i class="fa-solid fa-arrows-left-right"></i>
          {{ formatearFechaSinAnyo(dateRange.startDate) }} — {{ formatearFechaSinAnyo(dateRange.endDate) }}
        </span>
      </header>
      <div class="mv2-section__body">
        <ComparacionAnyo
          :items="orders"
          :ordersOlds="ordersOlds"
          :inicio="formatearFechaSinAnyo(dateRange.startDate)"
          :fin="formatearFechaSinAnyo(dateRange.endDate)"
        ></ComparacionAnyo>
      </div>
    </section>

    <!-- MODAL FECHA -->
    <b-modal v-model="modalVisible" title="Filtros de búsqueda" size="lg" hide-footer scrollable modal-class="mv2-modal">
      <b-row class="align-items-center mb-4 gx-3">
        <b-col md="5">
          <date-range-picker
            :ranges="ranges"
            :locale-data="locale"
            v-model="dateRange"
            :opens="'inline'"
            style="width: 100%"
          />
        </b-col>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import vSelect from "vue-select";

import axios from "@axios";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import moment from "moment";

import GraficaPaises from "../../layouts/components/map/paises.vue";
import GraficaCiudades from "../../layouts/components/map/ciudades.vue";
import ComparacionAnyo from "../../layouts/components/map/comparacionAnyo.vue";

const clusterIconUrls = [
  "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
  "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m2.png",
  "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m3.png",
  "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m5.png",
  "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m4.png",
];

const renderer = {
  render: ({ count, position }) => {
    let index = 0;
    if (count < 10) {
      index = 0;
    } else if (count < 50) {
      index = 1;
    } else if (count < 100) {
      index = 2;
    } else if (count < 500) {
      index = 3;
    } else {
      index = 4;
    }

    const sizeMap = [53, 56, 59, 62, 65];
    const size = sizeMap[index];
    const url = clusterIconUrls[index];

    return new google.maps.Marker({
      position,
      icon: {
        url,
        scaledSize: new google.maps.Size(size, size),
      },
      label: {
        text: String(count),
        color: "#fff",
        fontSize: "14px",
        fontWeight: "bold",
      },
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    });
  },
};

export default {
  components: {
    vSelect,
    DateRangePicker,
    GraficaPaises,
    GraficaCiudades,
    ComparacionAnyo,
  },
  data() {
    return {
      modalVisible: false,
      map: null,
      markers: [],
      markerClusterer: null,
      products: [],
      searchQuery: "",
      selectedCategory: "",
      categories: [],
      allMarkersData: [],
      visibleMarkers: 0,
      modoDiario: false,
      ordersCount: 0,
      primeraCarga: true,
      intervaloItems: null,
      dateRange: {
        startDate: moment().subtract(1, "days")._d,
        endDate: moment().subtract(1, "days")._d,
      },
      locale: {
        format: "dd/mm/yyyy",
        separator: " - ",
        applyLabel: "Buscar",
        cancelLabel: "Cancelar",
        fromLabel: "Desde",
        toLabel: "Hasta",
        customRangeLabel: "Personalizado",
        daysOfWeek: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
        monthNames: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        firstDay: 1,
      },
      ranges: {
        Hoy: [moment()._d, moment()._d],
        Ayer: [
          moment().subtract(1, "days")._d,
          moment().subtract(1, "days")._d,
        ],
        "Últimos 7 días": [moment().subtract(6, "days")._d, moment()._d],
        "Últimos 30 días": [moment().subtract(29, "days")._d, moment()._d],
        "Este mes": [moment().startOf("month")._d, moment().endOf("month")._d],
        "Mes pasado": [
          moment().subtract(1, "month").startOf("month")._d,
          moment().subtract(1, "month").endOf("month")._d,
        ],
        "Últimos 6 meses": [
          moment().subtract(6, "months").startOf("month")._d,
          moment().endOf("month")._d,
        ],
        "Últimos 12 meses": [
          moment().subtract(12, "months").startOf("month")._d,
          moment().endOf("month")._d,
        ],
      },
      cargando: false,
      orders: [],
      ordersOlds: [],
      tipoDatosCalcular: "Libras",
    };
  },
  async mounted() {
    await window.googleMapsReady;
    this.modoDiario = this.$route.params.id !== undefined;
    this.loaditems();
    this.initMap();

    if (this.modoDiario) {
      this.intervaloItems = setInterval(() => {
        this.loaditems(true);
      }, 120000);
    }
  },
  beforeDestroy() {
    if (this.intervaloItems) clearInterval(this.intervaloItems);
  },
  methods: {
    fmt(fecha) {
      return new Date(fecha).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
    },
    formatearFechaSinAnyo(fecha) {
      if (!fecha) return "";
      const opciones = { day: "2-digit", month: "2-digit" };
      return new Date(fecha).toLocaleDateString(undefined, opciones);
    },
    showMapMessage(message, position = null) {
      const mapCenter = this.map.getCenter();
      const infoWindow = new google.maps.InfoWindow({
        content: `<div style="font-weight: bold; color: green;">${message}</div>`,
        position: position || mapCenter,
      });

      infoWindow.open(this.map);
    },
    // auto = recarga automática cada 2 min: sin avisos de carga ni registro de uso
    loaditems(auto = false) {
      if (!auto) axios.post("/uso", { seccion: "map-v2" });

      if (!auto) this.cargando = true;
      function formatDate(date) {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }

      let urlOrder;

      if (this.modoDiario) {
        urlOrder = "/kpi/orders/dia";
      } else {
        const baseStart = new Date(this.dateRange.startDate);
        const baseEnd = new Date(this.dateRange.endDate);

        const from = formatDate(baseStart) + " 00:00:00";
        const to = formatDate(baseEnd) + " 23:59:59";

        urlOrder = `/map/orders?from=${from}&to=${to}`;

        const from_1year =
          formatDate(new Date(baseStart.getFullYear() - 1, baseStart.getMonth(), baseStart.getDate())) + " 00:00:00";
        const to_1year =
          formatDate(new Date(baseEnd.getFullYear() - 1, baseEnd.getMonth(), baseEnd.getDate())) + " 23:59:59";

        const from_2year =
          formatDate(new Date(baseStart.getFullYear() - 2, baseStart.getMonth(), baseStart.getDate())) + " 00:00:00";
        const to_2year =
          formatDate(new Date(baseEnd.getFullYear() - 2, baseEnd.getMonth(), baseEnd.getDate())) + " 23:59:59";

        const pedidosOld = [
          axios.get(`/map/orders?from=${from_1year}&to=${to_1year}`, { silencioso: auto }),
          axios.get(`/map/orders?from=${from_2year}&to=${to_2year}`, { silencioso: auto }),
        ];

        Promise.all(pedidosOld).then((responses) => {
          this.ordersOlds = [...responses[0].data, ...responses[1].data];
        });
      }

      const pedidos = [axios.get(urlOrder, { silencioso: auto })];

      const cargarProductos = this.products.length === 0;
      if (cargarProductos) {
        pedidos.push(axios.get("/shopify/products", { silencioso: auto }));
      }

      Promise.all(pedidos).then((responses) => {
        const nuevasOrders = responses[0].data;

        if (cargarProductos) {
          this.products = responses[1].data;
        }

        if (nuevasOrders.length === this.ordersCount) {
          return;
        }

        const antiguosIds = this.orders.map((order) => order.id);
        const nuevasDetectadas = nuevasOrders.filter(
          (order) => !antiguosIds.includes(order.id)
        );

        this.orders = nuevasOrders;

        this.orders.forEach((order) => {
          order.line_items = order.line_items
            .map((item) => {
              const matchedProduct = this.products.find((product) =>
                product.variants.some((variant) => variant.sku === item.sku)
              );

              if (
                matchedProduct &&
                matchedProduct.product_type &&
                matchedProduct.product_type != "Gift Cards"
              ) {
                return {
                  ...item,
                  product_type: matchedProduct.product_type,
                };
              }

              return null;
            })
            .filter((item) => item !== null);
        });

        if (nuevasDetectadas.length > 0 && this.modoDiario) {
          const excludedSkusInfoView = [
            "GIFT-PACKAGING",
            "DEBOSS-CUSTOMIZATION",
            "EXTRA-PIECE",
            "LEATHER-CUSTOMIZATION",
          ];

          nuevasDetectadas.forEach((nueva) => {
            const lat = parseFloat(nueva.shipping_address?.latitude);
            const lng = parseFloat(nueva.shipping_address?.longitude);

            if (!isNaN(lat) && !isNaN(lng)) {
              const skuToImage = {};
              nueva.line_items.forEach((item) => {
                if (excludedSkusInfoView.includes(item.sku)) return;
                const matchedProduct = this.products.find((product) =>
                  product.variants.some(
                    (variant) =>
                      variant.sku === item.sku && product.status != "draft"
                  )
                );
                if (!matchedProduct) return;

                const matchedVariant = matchedProduct.variants.find(
                  (variant) => variant.sku === item.sku
                );
                const variantImage = matchedProduct.images.find(
                  (img) => img.id === matchedVariant.image_id
                );

                skuToImage[item.sku] = variantImage
                  ? variantImage.src
                  : matchedProduct.image?.src || null;
              });

              const skusHtml = nueva.line_items
                .map((item) => {
                  const imgSrc = skuToImage[item.sku];
                  if (!imgSrc) return "";
                  return `<img src="${imgSrc}" alt="${item.sku}" title="${item.sku}" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; margin-right: 8px;" />`;
                })
                .join("");

              const mensaje = `
                  <div style="
                    padding: 10px 5px;
                    border-radius: 8px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    background-color: #ffffff;
                    font-family: 'Segoe UI', sans-serif;
                    color: #333;
                    max-width: 250px;
                    font-size: 14px;
                  ">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                      <div style="font-weight: 600;">Nuevo pedido: ${nueva.name}</div>
                      <button
                        onclick="this.closest('div[role=dialog]').parentElement.style.display='none'"
                        style="background: none; border: none; font-size: 18px; cursor: pointer; color: #999; transition: color 0.2s;"
                        onmouseover="this.style.color='#000'"
                        onmouseout="this.style.color='#999'"
                      >✕</button>
                    </div>
                    <div style="margin-top: 8px; line-height: 1.4;">
                      <small style="color: #666;">
                         <div style="display: flex; gap: 8px; flex-wrap: wrap; justify-content: center;">
                            ${skusHtml}
                          </div>
                      </small>
                    </div>
                  </div>
                `;

              if (!this.primeraCarga)
                this.showMapMessage(mensaje, { lat, lng });
            }
          });
        }

        this.ordersCount = nuevasOrders.length;
        this.orders = nuevasOrders;
        this.markers = [];
        this.allMarkersData = [];

        const excludedSkus = [
          "GIFT-PACKAGING",
          "DEBOSS-CUSTOMIZATION",
          "EXTRA-PIECE",
          "LEATHER-CUSTOMIZATION",
        ];

        this.orders.forEach((order) => {
          order.line_items.forEach((item, index) => {
            if (excludedSkus.includes(item.sku)) return;

            const matchedProduct = this.products.find((product) =>
              product.variants.some(
                (variant) =>
                  variant.sku === item.sku && product.status != "draft"
              )
            );
            if (!matchedProduct) return;

            const matchedVariant = matchedProduct.variants.find(
              (variant) => variant.sku === item.sku
            );
            const variantImage = matchedProduct.images.find(
              (img) => img.id === matchedVariant.image_id
            );

            const matchedImage = variantImage
              ? variantImage.src
              : matchedProduct.image?.src || null;

            if (
              matchedImage &&
              order.shipping_address?.latitude &&
              order.shipping_address?.longitude
            ) {
              const lat = parseFloat(order.shipping_address.latitude);
              const lng = parseFloat(order.shipping_address.longitude);

              if (!isNaN(lat) && !isNaN(lng)) {
                const offset = 0.0001;
                const orderWithOffset = {
                  ...order,
                  shipping_address: {
                    ...order.shipping_address,
                    latitude: lat + index * offset,
                    longitude: lng + index * offset,
                  },
                };

                this.addOrder(
                  orderWithOffset,
                  matchedImage,
                  item,
                  matchedProduct.product_type
                );
              }
            }
          });
        });

        if (this.primeraCarga) {
          this.primeraCarga = false;
        }

        this.filterMarkers();
        this.cargando = false;
      });
    },

    initMap() {
      this.map = new google.maps.Map(this.$refs.mapContainer, {
        center: { lat: 38.294008, lng: -0.58664 },
        zoom: 3,
      });
      this.markerClusterer = new MarkerClusterer({
        map: this.map,
        markers: this.markers,
        maxZoom: 15,
        renderer: renderer,
      });
    },
    resetMap() {
      this.map.setCenter({ lat: 38.294008, lng: -0.58664 });
      this.map.setZoom(3);
    },
    addOrder(order, image, item, category) {
      if (
        !order.shipping_address ||
        typeof order.shipping_address.latitude === "undefined" ||
        typeof order.shipping_address.longitude === "undefined"
      ) {
        return;
      }

      const lat = parseFloat(order.shipping_address.latitude);
      const lng = parseFloat(order.shipping_address.longitude);

      if (isNaN(lat) || isNaN(lng)) {
        return;
      }

      const marker = new google.maps.Marker({
        position: { lat, lng },
        title: order.name + "\n" + item.sku,
        icon: {
          url: image,
          size: new google.maps.Size(40, 40),
          scaledSize: new google.maps.Size(40, 40),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(20, 40),
        },
      });

      this.markers.push(marker);

      this.allMarkersData.push({
        marker,
        name: order.name.toLowerCase(),
        category: category.toLowerCase(),
        sku: item.sku.toLowerCase(),
        itemName: item.name.toLowerCase(),
      });

      if (category != "" && !this.categories.includes(category)) {
        this.categories.push(category);
        this.categories.sort();
      }
    },
    filterMarkers() {
      const query = this.searchQuery.toLowerCase().trim();
      let category = this.selectedCategory.toLowerCase();

      if (category === "") {
        category = "todas las categorías";
      }

      this.allMarkersData.forEach(({ marker }) => {
        marker.setMap(null);
      });

      this.markerClusterer.clearMarkers();

      const filteredMarkers = this.allMarkersData
        .filter(({ name, itemName, sku, category: cat }) => {
          const matchesQuery =
            !query ||
            name.includes(query) ||
            itemName.includes(query) ||
            sku.includes(query);

          const matchesCategory =
            category === "todas las categorías" || cat === category;

          return matchesQuery && matchesCategory;
        })
        .map((item) => item.marker);

      filteredMarkers.forEach((m) => m.setMap(this.map));

      this.markerClusterer.addMarkers(filteredMarkers);
      this.visibleMarkers = filteredMarkers.length;
    },
  },
  watch: {
    searchQuery() {
      this.filterMarkers();
    },
    selectedCategory() {
      this.filterMarkers();
    },
    dateRange() {
      this.loaditems();
      this.modalVisible = false;
    },
  },
};
</script>

<style lang="scss">
@import "../@core/scss/vue/libs/vue-select.scss";
@import "../@core/scss/vue/libs/chart-apex.scss";

.gm-style-iw-chr {
  display: none !important;
}

// Tipografía de las gráficas solo dentro de esta vista
.mv2 .apexcharts-canvas .apexcharts-text,
.mv2 .apexcharts-canvas .apexcharts-legend-text {
  font-family: "Plus Jakarta Sans", sans-serif !important;
}
</style>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

// ══════════════════════════════════════════════════════════════
// SALES ATLAS v2 — mismos tokens que el resto del ERP
// (slate / azul / naranja CTA · Plus Jakarta Sans + JetBrains Mono)
// ══════════════════════════════════════════════════════════════

$bg:        #F8FAFC;
$surface:   #FFFFFF;
$surface-2: #F1F5F9;
$line:      #E2E8F0;
$divider:   #EEF2F7;
$ink:       #1E293B;
$ink-2:     #334155;
$mute:      #64748B;
$soft:      #94A3B8;
$primary:   #3B82F6;
$primary-d: #2563EB;
$cta:       #F97316;
$cta-soft:  #FDBA74;

$sans: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
$mono: 'JetBrains Mono', 'SFMono-Regular', Menlo, monospace;

.mv2 {
  font-family: $sans;
  background: $bg;
  color: $ink;
  margin: -2rem;
  padding: 0 0 72px;
  min-height: calc(100vh - 4rem);
  font-feature-settings: "tnum", "zero";

  *, *::before, *::after { box-sizing: border-box; }
}

// ──────────── TOPBAR ────────────
.mv2-bar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  padding: 24px 32px 18px;
  border-bottom: 1px solid $line;
  background: $surface;
}

.mv2-kicker {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: $mono;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: $primary;

  &__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: $cta;
    animation: mv2-pulse 2s infinite;
  }

  &__live {
    padding: 2px 7px;
    border: 1px solid $cta;
    color: $cta;
    border-radius: 999px;
    font-size: 9px;
    letter-spacing: 0.2em;
    animation: mv2-blink 1.6s ease-in-out infinite;
  }
}

.mv2-bar__title {
  font-family: $sans;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.02em;
  margin: 6px 0 0;
  color: $ink;

  em {
    font-style: normal;
    font-weight: 500;
    color: $primary;
  }
}

.mv2-bar__nav {
  display: flex;
  gap: 20px;
  align-self: flex-end;
  padding-bottom: 6px;

  a {
    font-family: $mono;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: $mute;
    text-decoration: none;
    position: relative;
    padding-bottom: 2px;
    transition: color 150ms ease;

    &::after {
      content: '';
      position: absolute;
      left: 0; right: 100%; bottom: -2px;
      height: 2px;
      background: $primary;
      border-radius: 2px;
      transition: right 220ms cubic-bezier(.2,.7,.2,1);
    }
    &:hover { color: $ink; &::after { right: 0; } }
  }
}

.mv2-bar__tools {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.mv2-date {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 14px;
  background: $primary;
  color: #fff;
  border: 1px solid $primary;
  border-radius: 8px;
  font-family: $mono;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba($ink, 0.06);
  transition: all 150ms ease;

  i { font-size: 12px; color: rgba(#fff, 0.85); }
  em { font-style: normal; color: rgba(#fff, 0.6); margin: 0 2px; }
  &__spin { color: #fff; }

  &:hover { background: $primary-d; border-color: $primary-d; transform: translateY(-1px); }
}

.mv2-seg {
  display: inline-flex;
  height: 38px;
  padding: 3px;
  border: 1px solid $line;
  border-radius: 8px;
  background: $surface;

  button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0 12px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    font-family: $sans;
    font-size: 12px;
    font-weight: 600;
    color: $mute;
    cursor: pointer;
    transition: all 180ms ease;

    i { font-size: 11px; }

    &.is-on {
      background: $cta;
      color: #fff;
      box-shadow: 0 1px 2px rgba($ink, 0.1);
    }
    &:not(.is-on):hover { color: $ink; background: $surface-2; }
  }
}

// ──────────── HERO · MAPA ────────────
.mv2-hero {
  position: relative;
  height: clamp(480px, 68vh, 760px);
  border-bottom: 1px solid $line;
  background: $surface-2;
  overflow: hidden;
}

.mv2-hero__canvas {
  position: absolute;
  inset: 0;
}

.mv2-hero__filters {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 5;
  display: flex;
  gap: 8px;
  padding: 8px;
  background: rgba($surface, 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid $line;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba($ink, 0.1);
  max-width: calc(100% - 32px);
  flex-wrap: wrap;
}

.mv2-field {
  position: relative;
  display: block;
  margin: 0;

  &--search {
    width: 260px;
    i {
      position: absolute;
      left: 12px; top: 50%;
      transform: translateY(-50%);
      color: $soft;
      font-size: 12px;
      z-index: 2;
      pointer-events: none;
    }
  }
  &--select { width: 230px; }
}

// Los ::v-deep van bajo .mv2 a proposito: en la raiz, postcss-rtl + scoped generan [dir][data-v-xxx]
// y ninguna propiedad direccional (padding, margin...) llega a aplicarse.
.mv2 ::v-deep .mv2-field--search input {
  height: 38px !important;
  padding-left: 34px !important;
  border-radius: 8px !important;
  border: 1px solid $line !important;
  background: $surface !important;
  font-family: $sans !important;
  font-size: 13px !important;
  color: $ink !important;
  box-shadow: none !important;
  transition: all 150ms ease !important;

  &::placeholder { color: $soft; }
  &:focus {
    border-color: $primary !important;
    box-shadow: 0 0 0 3px rgba($primary, 0.12) !important;
  }
}

.mv2 ::v-deep .mv2-field--select .v-select {
  .vs__dropdown-toggle {
    min-height: 38px;
    padding: 0 6px;
    border: 1px solid $line !important;
    border-radius: 8px !important;
    background: $surface !important;
    box-shadow: none !important;
  }
  &.vs--open .vs__dropdown-toggle,
  .vs__dropdown-toggle:focus-within {
    border-color: $primary !important;
    box-shadow: 0 0 0 3px rgba($primary, 0.12) !important;
  }
  .vs__selected, .vs__search {
    font-family: $sans;
    font-size: 13px;
    color: $ink;
    padding: 0 6px;
    line-height: 36px;
    margin: 0;
  }
  .vs__open-indicator { fill: $soft; transform: scale(0.75); }
  .vs__dropdown-menu {
    background: $surface;
    border: 1px solid $line;
    border-radius: 8px;
    box-shadow: 0 12px 32px rgba($ink, 0.12);
    padding: 4px;
  }
  .vs__dropdown-option {
    font-family: $sans;
    font-size: 13px;
    color: $ink-2;
    padding: 8px 10px;
    border-radius: 6px;
    &--highlight { background: $surface-2; color: $primary; }
  }
}

.mv2-ghost {
  width: 38px;
  height: 38px;
  border: 1px solid $line;
  border-radius: 8px;
  background: $surface;
  color: $mute;
  cursor: pointer;
  transition: all 150ms ease;
  &:hover { background: $surface-2; border-color: $soft; color: $primary; }
}

.mv2-hero__loading {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 5;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: $surface;
  color: $mute;
  border: 1px solid $line;
  border-radius: 8px;
  font-family: $mono;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  box-shadow: 0 8px 24px rgba($ink, 0.1);
  .spinner-grow { color: $primary; }
}

.mv2-hero__stats {
  position: absolute;
  left: 16px;
  bottom: 16px;
  z-index: 5;
  display: flex;
  background: $surface;
  border: 1px solid $line;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba($ink, 0.12);
  overflow: hidden;
}

.mv2-stat {
  display: flex;
  flex-direction: column;
  padding: 12px 20px 10px;
  min-width: 112px;
  border-right: 1px solid $divider;
  &:last-child { border-right: 0; }

  &__n {
    font-family: $mono;
    font-size: 26px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -0.02em;
    color: $ink;
    font-feature-settings: "tnum";
  }
  &__l {
    margin-top: 6px;
    font-family: $mono;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: $mute;
  }
  &:first-child .mv2-stat__n { color: $primary; }
}

// ──────────── SECCIONES ────────────
.mv2-section {
  padding: 32px 32px 4px;
  animation: mv2-rise 500ms cubic-bezier(.2,.7,.2,1) both;
  animation-delay: calc(var(--i, 0) * 90ms + 120ms);
}

.mv2-section__head {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: baseline;
  gap: 14px;
  padding-bottom: 12px;
  margin-bottom: 18px;
  border-bottom: 1px solid $line;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0; bottom: -1px;
    width: 64px;
    height: 2px;
    background: $primary;
    border-radius: 2px;
  }
}

.mv2-section__num {
  font-family: $mono;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: $cta;
}

.mv2-section__title {
  font-family: $sans;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.015em;
  line-height: 1.1;
  margin: 0;
  color: $ink;

  em { font-style: normal; font-weight: 500; color: $mute; }
}

.mv2-section__meta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: $mono;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: $mute;
  i { color: $soft; font-size: 10px; }
}

// Las gráficas vienen envueltas en .card (b-card-code)
.mv2 ::v-deep .mv2-section__body .card {
  background: $surface;
  border: 1px solid $line;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba($ink, 0.04);
  transition: box-shadow 200ms ease;
  &:hover { box-shadow: 0 2px 8px rgba($ink, 0.04); }
}

// ──────────── MODAL ────────────
.mv2 ::v-deep .mv2-modal .modal-content {
  border-radius: 14px;
  border: 1px solid $line;
  font-family: $sans;
}
.mv2 ::v-deep .mv2-modal .modal-title {
  font-family: $sans;
  font-weight: 700;
  font-size: 18px;
}

// ──────────── ANIMACIONES ────────────
@keyframes mv2-rise {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: none; }
}
@keyframes mv2-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}
@keyframes mv2-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.55; transform: scale(0.85); }
}
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
  }
}

// ──────────── RESPONSIVE ────────────
@media (max-width: 900px) {
  .mv2-bar { padding: 18px 20px 14px; }
  .mv2-bar__nav { display: none; }
  .mv2-bar__title { font-size: 24px; }
  .mv2-section { padding: 24px 20px 4px; }
  .mv2-section__head { grid-template-columns: auto 1fr; }
  .mv2-section__meta { grid-column: 1 / -1; }
  .mv2-hero__stats { right: 16px; }
  .mv2-stat { flex: 1; min-width: 0; padding: 10px 12px 8px; }
  .mv2-stat__n { font-size: 20px; }
  .mv2-field--search, .mv2-field--select { width: 100%; }
}

// ──────────── DARK MODE ────────────
.dark-layout .mv2 ::v-deep {
  background: #161616;
  color: #d0d2d6;

  .mv2-bar { background: #1f1f1f; border-bottom-color: #2c2c2c; }
  .mv2-bar__title { color: #e4e6eb; }
  .mv2-bar__nav a { color: #8e9099; &:hover { color: #e4e6eb; } }
  .mv2-seg { background: #1f1f1f; border-color: #2c2c2c; }
  .mv2-hero { border-bottom-color: #2c2c2c; background: #161616; }
  .mv2-hero__filters { background: rgba(31, 31, 31, 0.9); border-color: #2c2c2c; }
  .mv2-field--search input,
  .mv2-field--select .vs__dropdown-toggle { background: #242424 !important; border-color: #2c2c2c !important; color: #e4e6eb !important; }
  .mv2-field--select .vs__selected { color: #e4e6eb; }
  .mv2-ghost { background: #242424; border-color: #2c2c2c; color: #8e9099; }
  .mv2-hero__loading { background: #242424; border-color: #2c2c2c; color: #8e9099; }
  .mv2-hero__stats { background: #1f1f1f; border-color: #2c2c2c; }
  .mv2-stat { border-right-color: #2c2c2c; }
  .mv2-stat__n { color: #e4e6eb; }
  .mv2-section__head { border-bottom-color: #2c2c2c; }
  .mv2-section__title { color: #e4e6eb; }
  .mv2-section__body .card { background: #1f1f1f; border-color: #2c2c2c; }
}
</style>
